import { render, staticRenderFns } from "./zdjttl.vue?vue&type=template&id=24413256&scoped=true&"
import script from "./zdjttl.vue?vue&type=script&lang=js&"
export * from "./zdjttl.vue?vue&type=script&lang=js&"
import style0 from "./zdjttl.vue?vue&type=style&index=0&id=24413256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24413256",
  null
  
)

export default component.exports